var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-layout",attrs:{"id":"login-layout"}},[_c('Head',{attrs:{"page":_vm.$route.name}}),_c('router-view'),_c('Footer',{attrs:{"page":_vm.$route.name,"showLogout":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }